<head>
  <title>{{'APP_NAME'|translate}}</title>
</head>
<app-header [navbarBrandRouterLink]="['/dashboard']" [fixed]="true"
  [navbarBrandFull]="{src: 'assets/images/logo/petiak.png', width: 89, height: 37, alt: 'Petiak Logo'}"
  [navbarBrandMinimized]="{src: 'assets/images/logo/petiak-small.png', width: 30, height: 30, alt: 'Petiak Logo'}"
  [sidebarToggler]="'lg'" [asideMenuToggler]="false" [mobileAsideMenuToggler]="false">
  <div class="ml-3 w-20 w-md-10" *ngIf="access.userSelector">
    <ng-template #typeahead let-r="result" let-t="term">
      <span>{{ r.name }} {{ r.family}}</span>
      <span class="float-left">{{r.username}}</span>
    </ng-template>
    <div class="row mt-1 flexContainer">
      <div class="input-group">
        <div class="input-group-prepend">
          <span *ngIf="selectedAccount && access.deleteWorklog" class="fa fa-trash input-group-text"
            (click)="deleteLog()"></span>
        </div>
        <input *ngIf="selectedAccount" type="text" class="form-control" readonly="true" [(ngModel)]="selectedAccount">
        <input *ngIf="!selectedAccount" type="text" class="form-control" [(ngModel)]="targetUser"
          [ngbTypeahead]="search" [inputFormatter]="inputFormatter" [resultTemplate]="typeahead"
          (ngModelChange)="typeaheadClicked($event)">
        <div class="input-group-prepend">
          <span *ngIf="selectedAccount" class="fa fa-check input-group-text" (click)="unselectUser()"></span>
          <span *ngIf="!selectedAccount && searchMode === 'account'" class="fa fa-user input-group-text"
            (click)="searchMode = 'user'"></span>
          <span *ngIf="!selectedAccount && searchMode === 'user'" class="fa fa-plug input-group-text"
            (click)="searchMode = 'account'"></span>
        </div>
      </div>
    </div>
  </div>

  <ul class="nav navbar-nav" [ngClass]="{'mr-auto': rtl,'ml-auto': !rtl}">
    <li class="nav-item">
      <a class="nav-link theme-toggle" (click)="toggleTheme()" role="switch" [attr.aria-checked]="theme === 'dark'"
        data-toggle="tooltip" data-html="true" data-placement="bottom"
        title="{{(theme === 'dark' ? 'LIGHT_THEME' : 'DARK_THEME') | translate}}">
        <i class="fa fa-lg" [ngClass]="theme === 'dark' ? 'fa-sun-o' : 'fa-moon-o'"></i>
      </a>
    </li>
    <li *ngIf="!isMobile" class="nav-item">
      <a class="nav-link" (click)="createIssue()" data-toggle="tooltip" data-html="true" data-placement="bottom"
        title="{{'ADD_ISSUE' | translate}}">
        <i class="fa fa-plus-square fa-lg"></i>
      </a>
    </li>
    <li *ngIf="!isMobile" class="nav-item">
      <a class="nav-link" (click)="openBasket()" data-toggle="tooltip" data-html="true" data-placement="bottom"
        title="{{'BASKET' | translate}}">
        <i class="fa fa-shopping-basket fa-lg"></i>
      </a>
    </li>

    <li *ngIf="!isMobile" class="nav-item" data-toggle="tooltip" data-html="true" data-placement="bottom"
      title="{{'MESSAGES' | translate}}">
      <a class="nav-link" role="button" (click)="openMessages();">
        <i class="fa fa-envelope-o fa-lg"></i>
        <!-- <span class="badge badge-pill badge-warning">{{unreadMsg}}</span> -->
      </a>
    </li>
    <li class="nav-item dropdown ml-1" dropdown [attr.placement]="rtl ? 'bottom left' : 'bottom right'">
      <a class="nav-link" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle
        (click)="false">
        <span class="user-name d-md-down-none">{{ account?.fullname }}</span>
        <i class="fa fa-angle-down fa-lg"></i>
      </a>
      <div class="dropdown-menu" [ngClass]="{'dropdown-menu-right': !rtl,'dropdown-menu-left': rtl}" *dropdownMenu>
        <a class="dropdown-item" (click)="createIssue();" *ngIf="isMobile">
          <i class="fa fa-plus-square"></i> {{'ADD_ISSUE' | translate }}</a>
        <a class="dropdown-item" (click)="openMessages();" *ngIf="isMobile">
          <i class="fa fa-envelope-o"></i> {{'MESSAGES' | translate }}</a>
        <a class="dropdown-item" (click)="openBasket()" *ngIf="isMobile">
          <i class="fa fa-shopping-basket"></i> {{'BASKET' | translate }}</a>
        <a class="dropdown-item" *ngIf="account && account?.balance !== 0" (click)="openStatement();">
          <i class="fa fa-money"></i> {{'LAST_BALANCE' | translate}}: {{ account?.balance | money}}</a>
        <a class="dropdown-item" *ngIf="account && roles.includes('FINANCE_MNG')" (click)="recalcBalance();">
          <i class="fa fa-money"></i> {{'RECALC_BALANCE' | translate}}</a>
        <a class="dropdown-item" (click)="changePass();" *ngIf="!selectedAccount">
          <i class="fa fa-key"></i> {{'CHANGE_PASSWORD' | translate }}</a>
        <a class="dropdown-item" (click)="resetPassword()" *ngIf="selectedAccount && roles.includes('PERSONNEL')">
          <i class="fa fa-lock"></i> {{'RESET_PASSWORD' | translate }}</a>
        <a class="dropdown-item" (click)="openProfile()" *ngIf="access.editAccount">
          <i class="fa fa-user"></i> {{'ACCOUNT' | translate }}</a>
        <a class="dropdown-item" (click)="openAgentProfile()" *ngIf="account && account.agent_id && access.editAccount">
          <i class="fa fa-user"></i> {{'AGENT_ACCOUNT' | translate }}</a>
        <a class="dropdown-item" (click)="call(selectedAccount, 'mobile')"
          *ngIf="selectedAccount && account && roles.includes('PERSONNEL')">
          <i class="fa fa-mobile"></i> {{'CALL_MOBILE' | translate }}</a>
        <a class="dropdown-item" (click)="call(selectedAccount, 'tel')"
          *ngIf="selectedAccount && account && roles.includes('PERSONNEL')">
          <i class="fa fa-phone"></i> {{'CALL_TEL' | translate }}</a>

        <a *ngFor="let legal of legals" class="dropdown-item" (click)="select({ username: legal.username })">
          <i class="fa fa-building"></i> {{ legal.fullname}}</a>

        <a class="dropdown-item" *ngIf="!selectedAccount" (click)="logOut()">
          <i class="fa fa-sign-out"></i> {{'LOGOUT' | translate }}</a>
      </div>
    </li>
  </ul>
</app-header>
<div class="app-body">
  <app-sidebar [fixed]="true" [display]="'lg'">
    <app-sidebar-nav [navItems]="navItems"></app-sidebar-nav>
    <app-sidebar-minimizer></app-sidebar-minimizer>
  </app-sidebar>
  <main class="main bg-white">
    <router-outlet></router-outlet>
  </main>
</div>
<app-footer>
  <div dir="ltr" class="mx-auto sans">
    <span>Copyright © 2007-{{currentYear}}
      <a href="https://www.petiak.com">Petiak</a>. All Rights Reserved. Ver {{version}}
    </span>
  </div>
</app-footer>